export default __webpack_public_path__ + "images/c50caacaa06c2742ee250c3db6a69924.png";